import React, { ReactNode, useEffect, useMemo } from 'react'
import './ModalChildren.css'

import { useOutsideClick } from '../../../hook/useOutsideClick'
import XmarkIcon from '../../atoms/iconsComponent/XmarkIcon'
import { ModalChildrenPar } from 'components/types/types'
import clsx from 'clsx'


interface ModalProps {
  title?: string
  children?: ReactNode
  modalIsOpen?: boolean
  setModalIsOpen?: (param: ModalChildrenPar) => void
  closeButton?: boolean
}

const ModalChildren = ({ title, children, closeButton, modalIsOpen, setModalIsOpen }: ModalProps) => {

  const handleClickOutside = () => {
    setModalIsOpen?.({
      title: "",
      children: "",
      modalIsOpen: false,
      closeButton: false
    });
  };

  const handleOutsideClick = (event: Event) => {
    event.stopPropagation();
  };


  const ref = useOutsideClick(handleClickOutside);

  const showModal = useMemo(() => {

    if (modalIsOpen) {
      return (
        <div className={clsx(
          "d-flex modal justify-content-center w-100 h-100 backdrop align-items-media"
        )}>

          <div ref={ref} onClick={(e) => handleOutsideClick(e as any)} className="d-flex flex-column bg-white  ">
            {closeButton &&
              <div className="d-flex w-100 mt-2 justify-content-center align-items-center">
                <h3 className='modal-title'>{title}</h3>
                <a className='close-button' onClick={() =>
                  handleClickOutside()} href="#"><XmarkIcon className='close-button' /></a>
              </div>}
            <div className='d-flex w-100 justify-content-center  modalContent'>
              {children}
            </div>

          </div>
        </div>

      )
    } else { return null }
  }, [modalIsOpen, closeButton, children])

  return showModal

}

export default ModalChildren